// Manually transcribed from public/assets/css/styles.css's :root and
// :root[data-theme="dark"] blocks - keep these two files in sync if the
// design tokens ever change. Only the subset MUI's own built-in components
// need internally (Dialog backdrop, focus colors, etc.) lives here; bespoke
// styled-components reference the CSS custom properties (var(--surface),
// var(--shadow), ...) directly instead of duplicating values into JS, so
// dark mode "just works" for them with zero React-side re-implementation.
export const pink = {
  50: "#fff1f6",
  100: "#ffe4ef",
  200: "#ffc2da",
  300: "#ffa3c7",
  400: "#ff7fb1",
  500: "#ff5a9a",
  600: "#e64986",
  700: "#c7366f",
} as const;

export const lightTokens = {
  ink: "#3a0f22",
  muted: "#6b2b45",
  bodyBgSolid: "#fff8fb",
} as const;

export const darkTokens = {
  ink: "#ffe0ec",
  muted: "#cf94ae",
  bodyBgSolid: "#170c11",
} as const;
